import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Alerta from "../components/Alerta";

import $ from "jquery";
import useAuth from "../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
 

const ValidacionSeguridad = () => {
  const [tokenValido, setTokenValido] = useState(false);
  const [alerta, setAlerta] = useState({});

  const {listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

   
  let minValidacionSeguridad = Number(process.env.REACT_APP_MIN_VALIDACION_SEGURIDAD);
  let segValidacionSeguridad = Number(process.env.REACT_APP_SEG_VALIDACION_SEGURIDAD);
  const dataDefaultMinSeng = {min:minValidacionSeguridad,seg:segValidacionSeguridad}
  let [minutosCodigo, setMinutosCodigo] = useState(dataDefaultMinSeng.min);
  let [segundosCodigo, setSegundosCodigo] = useState(dataDefaultMinSeng.seg);
  
  
   
  const navigate = useNavigate();
  const params = useParams();
  const { token } = params;

  
  const [codigoDesktop, setCodigoDesktop] = useState("");

  const [phone1, setPhone1] = useState("");
  const [phone2, setPhone2] = useState("");
  const [phone3, setPhone3] = useState("");
  const [phone4, setPhone4] = useState("");
  const [phone5, setPhone5] = useState("");
  const [phone6, setPhone6] = useState("");


  useEffect(() => {
    const comprobarToken = async () => {
      try {
         
        setTokenValido(true);
      } catch (error) {
        setAlerta({
          msg: "El token se ha expirado, volver a enviar el correo",
          error: true,
          cargaPrincipal: true,
        });
         
      }
    };
    comprobarToken();
  }, []);

  
  useEffect(() => {
    let sampleInterval = setInterval(() => {
      if (segundosCodigo > 0) {
        setSegundosCodigo(segundosCodigo - 1);
      }
      if (segundosCodigo === 0) {
        if (minutosCodigo === 0) {
          clearInterval(sampleInterval);
        } else {
          setMinutosCodigo(minutosCodigo - 1);
          setSegundosCodigo(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(sampleInterval);
    }
   });
  
   
  
  let btnReenviarCodigo=() =>{

    if(minutosCodigo == 0 && segundosCodigo == 0){ 
      setMinutosCodigo(dataDefaultMinSeng.min);
      setSegundosCodigo(dataDefaultMinSeng.seg);
     let sampleInterval = setInterval(() => {
      if (segundosCodigo > 0) {
        setSegundosCodigo(segundosCodigo - 1);
      }
      if (segundosCodigo === 0) {
        if (minutosCodigo === 0) {
          clearInterval(sampleInterval);
        } else {
          setMinutosCodigo(minutosCodigo - 1);
          setSegundosCodigo(59);
        }
      }
    }, 1000);
        clearInterval(sampleInterval);
    }
     
   
  }

  
 

  useEffect(() => {
    const validateCodeMovil = () => {
      var $inputs = $("#vcode").find("input");

      
      $inputs.on("keyup", processInput);

      
      function processInput(e) {
        var x = e.charCode || e.keyCode;
        if ((x == 8 || x == 46) && this.value.length == 0) {
          var indexNum = $inputs.index(this);
          if (indexNum != 0) {
            $inputs.eq($inputs.index(this) - 1).focus();
          }
        }

        if (ignoreChar(e)) return false;
        else if (this.value.length == this.maxLength) {
          $(this).next("input").focus();
        }
      }
      function ignoreChar(e) {
        var x = e.charCode || e.keyCode;
        if (x == 37 || x == 38 || x == 39 || x == 40) return true;
        else return false;
      }
    };
    validateCodeMovil();
  }, [phone1, phone2, phone3, phone4, phone5, phone6]);

  const { msg, cargaPrincipal } = alerta;

  const soloLetrasNumeros = (e) => {
    let regex = new RegExp("^[A-Za-z0-9]+$");
    let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (!regex.test(key) || e.target.value.length === 6) {
      e.preventDefault();
      return false;
    }
  };
  const handleOnSubmitDesktop = async (e) => {
    e.preventDefault();
    if (codigoDesktop.length !== 6) {
      setAlerta({
        msg: `${lbl_validacion_msj_codigo_debe} 6 ${lbl_validacion_digitos}.`,
        error: true,
        cargaPrincipal: false,
      });
      return;
    }

    try {
      setAlerta({});

     

      navigate(`/auth/ressetPassword/${token}`);
    } catch (error) {
      setAlerta({
        msg: "El codigo se a expirado o no valido, volver a enviar el correo.",
        error: true,
        cargaPrincipal: false,
      });
    }
    
  };

  const handleOnSubmitMovile = (e) => {
    e.preventDefault();

    if ([phone1, phone2, phone3, phone4, phone5, phone6].includes("")) {
      setAlerta({
        msg: `${lbl_validacion_msj_codigo_debe} 6 ${lbl_validacion_digitos}.`,
        error: true,
        cargaPrincipal: false,
      });

      return;
    }

    try {
      setAlerta({});
      

      navigate(`/auth/ressetPassword/${token}`);
    } catch (error) {
      setAlerta({
        msg: "El codigo se a expirado o no valido, volver a enviar el correo.",
        error: true,
      });
    }
  };

  useEffect(() => {
    
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        seguridad_validacion: obtenerLabelEtiqueta(
          "lbl_seguridad_validacion",
          listadoEtiquetas
        ),
        reenviar: obtenerLabelEtiqueta(
          "lbl_seguridad_msj_reenviar",
          listadoEtiquetas
        ),
        restaurar: obtenerLabelEtiqueta(
          "lbl_global_restaurar",
          listadoEtiquetas
        ),
        volver_inicio: obtenerLabelEtiqueta(
          "lbl_global_msj_volver_inicio",
          listadoEtiquetas
        ),
        seguridad_msj_ingrese_codigo: obtenerLabelEtiqueta(
          "lbl_seguridad_msj_ingrese_codigo",
          listadoEtiquetas
        ),
        seguridad_msj_ingresar_codigo: obtenerLabelEtiqueta(
          "lbl_seguridad_msj_ingresar_codigo",
          listadoEtiquetas
        ),
        lbl_validacion_digitos: obtenerLabelEtiqueta(
          "lbl_validacion_digitos",
          listadoEtiquetas
        ),
        lbl_validacion_msj_codigo_debe: obtenerLabelEtiqueta(
          "lbl_validacion_msj_codigo_debe",
          listadoEtiquetas
        ),
        
      });
    }
  }, [listadoEtiquetas]);
  const { seguridad_validacion,reenviar,restaurar,volver_inicio,seguridad_msj_ingrese_codigo,seguridad_msj_ingresar_codigo,lbl_validacion_digitos,
    lbl_validacion_msj_codigo_debe } = etiquetas;

  return (
    <div className="login-content va-middle">
      <div className="center">
        <div className="log-title">
          <h1>{seguridad_validacion}</h1>
          <div className="separator"></div>
        </div>

        {msg && cargaPrincipal && (
          <div className="text-center mt-5">
            

            <Alerta alerta={alerta} />
            <Link to="/auth" className="mt-4 d-block">
              {volver_inicio}
            </Link>
          </div>
        )}

        {msg && cargaPrincipal == false && (
          <>
            <Alerta alerta={alerta} />
          </>
        )}

        {tokenValido && (
          <>
            <div className="description text-center ">
              <p>
                {seguridad_msj_ingrese_codigo}
              </p>
              <a onClick={btnReenviarCodigo} className={`d-block text-muted ${minutosCodigo <1 && segundosCodigo <1 && 'habilitadoCode'}`} >
                {reenviar} <span>{
                minutosCodigo< 10 ?`0${minutosCodigo}`:minutosCodigo}{':'}
                {segundosCodigo< 10 ?`0${segundosCodigo}`:segundosCodigo  }</span>
              </a>
            </div>
            <form
              onSubmit={handleOnSubmitDesktop}
              className="mb-4 d-sm-none d-md-block"
            >
              <div>
                <input
                  autoComplete="off"
                  type="text"
                  className="form-control login-control form-control-sm"
                  id="exampleFormControlInput1"
                  placeholder={seguridad_msj_ingresar_codigo}
                  value={codigoDesktop}
                  onPaste={(e)=> {e.preventDefault()}}
                  onKeyPress={(e) => soloLetrasNumeros(e)}
                  maxLength={6}
                  minLength={6}
                  onChange={(e) => {
                    setCodigoDesktop(e.target.value);
                  }}
                />
              </div>
               

              <div className="text-center mt-5">
                <button type="submit" className="btn btn-send mb-3">
                  {restaurar}
                </button>
                <Link to="/auth" className="mt-4 d-block">
                  {volver_inicio}
                </Link>
              </div>
            </form>

            <form
              onSubmit={(e) => {
                handleOnSubmitMovile(e);
              }}
              className="vcode d-block d-sm-block d-md-none"
            >
              <div id="vcode">
                <input
                  autoComplete="off"
                  type="phone"
                  className="vcode-input"
                  maxLength="1"
                  id="vcode1"
                  value={phone1}
                  onChange={(e) => {
                    setPhone1(e.target.value);
                  }}
                />
                <input
                  autoComplete="off"
                  type="phone"
                  className="vcode-input"
                  maxLength="1"
                  value={phone2}
                  onChange={(e) => {
                    setPhone2(e.target.value);
                  }}
                />
                <input
                  autoComplete="off"
                  type="phone"
                  className="vcode-input"
                  maxLength="1"
                  value={phone3}
                  onChange={(e) => {
                    setPhone3(e.target.value);
                  }}
                />
                <input
                  autoComplete="off"
                  type="phone"
                  className="vcode-input"
                  maxLength="1"
                  value={phone4}
                  onChange={(e) => {
                    setPhone4(e.target.value);
                  }}
                />
                <input
                  autoComplete="off"
                  type="phone"
                  className="vcode-input"
                  maxLength="1"
                  value={phone5}
                  onChange={(e) => {
                    setPhone5(e.target.value);
                  }}
                />
                <input
                  autoComplete="off"
                  type="phone"
                  className="vcode-input"
                  maxLength="1"
                  value={phone6}
                  onChange={(e) => {
                    setPhone6(e.target.value);
                  }}
                />
              </div>

              <div className="text-center mt-5">
                <button type="submit" className="btn btn-send mb-3">
                  {restaurar}
                </button>
                <Link to="/auth" className="mt-4 d-block">
                  {volver_inicio}
                </Link>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ValidacionSeguridad;
